import { getLocalizedPageNavigator } from './shareMeta';

export const DEFAULT_DOCUMENT_TITLE = '即享影像 | 企业级即时影像';

const normalizeTitle = (value?: string): string => {
  return typeof value === 'string' ? value.trim() : '';
};

export const resolveDocumentTitle = (
  preferredTitle?: string,
  fallbackTitle: string = DEFAULT_DOCUMENT_TITLE
): string => {
  return (
    normalizeTitle(preferredTitle) ||
    normalizeTitle(getLocalizedPageNavigator()) ||
    normalizeTitle(fallbackTitle)
  );
};

export const setDocumentTitle = (
  preferredTitle?: string,
  fallbackTitle: string = DEFAULT_DOCUMENT_TITLE
): string => {
  if (typeof document === 'undefined') {
    return '';
  }

  const nextTitle = resolveDocumentTitle(preferredTitle, fallbackTitle);
  document.title = nextTitle;
  return nextTitle;
};
